import useAxiosInterceptor from 'src/services/interceptor';
import { patientApiPaths } from '../constants';

class PatientScreeningService {
  private axiosInstance;

  constructor() {
    // `useAxiosInterceptor` is an axios-instance factory, not a React hook -- it calls no
    // hooks itself. The `use` prefix is what trips the rule here.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    this.axiosInstance = useAxiosInterceptor();
  }

  getScreening = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.createPatient}/${payload?.patientId}/${patientApiPaths.screeningDetails}/screening-all`,
      {
        params: payload?.params,
      }
    );
  };

  getSingleScreening = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.createPatient}/${payload?.patientId}/${patientApiPaths.screeningDetails}/${payload.screeningId}`
    );
  };

  /**
   * JOTFORM-DISCONNECT(BRK-1926): raw ReForm submission JSON of a native screening — the
   * prefill for the native edit page. 400s for legacy Jotform-era rows (no stored JSON);
   * gate calls on the list row's `submissionDataAvailable`.
   */
  getScreeningSubmissionData = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.createPatient}/${payload?.patientId}/${patientApiPaths.screeningDetails}/${payload?.screeningId}/submission-data`
    );
  };

  createScreening = (payload: any) => {
    return this.axiosInstance.post(
      `${patientApiPaths.createPatient}/${payload?.patientId}${payload.patientId}`
    );
  };

  editScreening = (payload: any) => {
    return this.axiosInstance.post(
      `${patientApiPaths.createPatient}/${payload?.patientId}${payload.patientId}`
    );
  };

  getScreeningType = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.createPatient}/${payload?.patientId}/${patientApiPaths.screeningDetails}/screening-type`
    );
  };

  getDisciplineType = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.createPatient}/${payload?.patientId}${patientApiPaths.screeningDetails}/discipline-type`,
      {
        params: { episodeOfCareId: payload?.episodeOfCareId },
      }
    );
  };

  getAddScreeningGetFormId = (payload: any) => {
    return this.axiosInstance.get(
      `${patientApiPaths.getFormIdOfScreening}/${payload?.patientId}/screening-details/get-screening-template`
    );
  };

  postScreeningSubmission = (payload: any) => {
    const { patientId, ...restPayload } = payload;
    return this.axiosInstance.put(
      `/provider/patient/${payload?.patientId}/screening-details/save-screening-submission`,
      null,
      {
        params: restPayload,
      }
    );
  };
}

const patientScreeningService = new PatientScreeningService();

Object.freeze(patientScreeningService);

export default patientScreeningService;
